import { setBearerToken, setUserData } from '@/common/axios';
import {
  ENDPOINT_LOGIN,
  ENDPOINT_SESSION,
  ENDPOINT_VALIDATE,
} from '@/common/constants';
import { URL } from '@/common/constants/oneid';
import { HttpApi } from '@/common/http';
import useStore from '@/lib/store';
import { zodResolver } from '@hookform/resolvers/zod';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'sonner';
import { AuthFormData, authSchema } from '../schema';
import { useSearchParamsState } from './useSearchParamsState';

const httpApi = new HttpApi();

export const useAuth = () => {
  const [code] = useSearchParamsState('code', '');
  const { fetchUser } = useStore();
  const [isLoading, setIsLoading] = useState(false);
  const form = useForm<AuthFormData>({
    resolver: zodResolver(authSchema),
    defaultValues: {
      username: '',
      password: '',
    },
  });

  const authLogin = ({ data, config }: any) => {
    return httpApi.post(ENDPOINT_LOGIN, data, config);
  };
  const onSubmitOneID = async () => {
    try {
      window.location.href = URL;
    } catch (error: any) {
      toast.error(
        error?.response?.data?.message || 'Login yoki parol noto‘g‘ri',
      );
    }
  };
  useEffect(() => {
    const validateAndLogin = async () => {
      try {
        const token = await httpApi.post(ENDPOINT_SESSION, {});
        const res: any = await httpApi.post(
          ENDPOINT_VALIDATE,
          { code },
          {
            headers: {
              Authorization: `Bearer ${token?.id}`,
            },
          },
        );
        const sessionId = res?.session_id;

        if (sessionId) {
          setBearerToken(token?.id);
          await setUserData(sessionId);
          await setBearerToken(sessionId);
          await fetchUser();
          await toast.success('Muvaffaqiyatli kirdingiz!');
        } else {
          toast.error('Session ID topilmadi');
        }
      } catch (error: any) {
        toast.error(
          error?.response?.data?.message || 'Login yoki parol noto‘g‘ri',
        );
      }
    };

    if (code) {
      validateAndLogin();
    }
  }, [code]);

  const onSubmit = async (data: AuthFormData): Promise<void> => {
    try {
      setIsLoading(false);
      const token = await httpApi.post(ENDPOINT_SESSION, {});
      const response = await authLogin({
        data,
        config: { headers: { Authorization: `Bearer ${token?.id}` } },
      });

      setUserData(response?.session_id);
      setBearerToken(response?.session_id);
      fetchUser();
      toast.success('Muvaffaqiyatli kirdingiz!');
      setIsLoading(true);
    } catch (error: any) {
      setIsLoading(false);
      toast.error(
        error?.response?.data?.message || 'Login yoki parol noto‘g‘ri',
      );
      console.error('Login error:', error);
    }
  };
  const handleErrors = (errors: any) => {
    console.log('Form validation errors:', errors);
  };
  const handleForm = form.handleSubmit(onSubmit, handleErrors);

  return {
    form,
    isLoading,
    handleForm,
    onSubmitOneID,
  };
};
